import {  makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  bacnetControlPanel: {
    padding: '0 10px',
    width: '100%',
    overflow: 'hidden',
  },
  // Mapping-area mode: the panel fills the control column's height so the
  // body below gets a definite size for useFitScale to measure.
  bacnetControlPanel_fitToPanel: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  bacnetControlPanel__header: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingTop: '25px',
    paddingBottom: '25px',
    justifyContent: 'center',
    position: 'relative',
  },
  bacnetControlPanel__temperature: {
    fontSize: '24px',
    fontWeight: '400',
    lineHeight: '28.13px',
    letterSpacing: '-0.03em',
    color: '#9B8B9B',
    position: 'absolute',
    left: 0,
    display: 'flex',
    '&>span:last-child': {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '18.75px',
      marginLeft: '3px',
    },
  },
  bacnetControlPanel__unitName: {
    fontSize: '28px',
    fontWeight: '400',
    lineHeight: '32.81px',
    color: '#FFFFFF',
    textAlign: 'center',
  },
  bacnetControlPanel__scheduleButton: {
    position: 'absolute',
    right: 16,
    display: 'flex',
    alignItems: 'center',
  },
  scheduleButton: {
    color: '#9B8B9B',
    width: '40px',
    height: '40px',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  bacnetControlPanel__body: {
    position: 'relative',
    borderRadius: '8px',
    minHeight: '400px',
    overflow: 'hidden',
    [theme.breakpoints.up('desktop2k')]: {
      height:1000,
    },
  },
  // Mapping-area mode: the body takes the remaining height instead of growing
  // with its content, so the canvas is scaled down to it rather than cropped.
  bacnetControlPanel__body_fitToPanel: {
    flex: 1,
    minHeight: 0,
    boxSizing: 'border-box',
    // Space under the canvas. useFitScale measures the content box, so the
    // canvas is fitted above this padding rather than over it.
    paddingBottom: 16,
    [theme.breakpoints.up('desktop2k')]: {
      height: 'auto',
    },
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    width: '100%',
  },
  emptyState: {
    padding: '12px',
    backgroundColor: '#2a2a3e',
    borderRadius: '8px',
    minHeight: '400px',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyStateText: {
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '21.09px',
    color: '#FFFFFF',
  },
  scalableMappingArea: {
    width: 486,
    height: 495,
    position: 'absolute',
    top: 0,
    left: '50%',
    transformOrigin: 'top center', // Scale from the top edge, keeping the canvas centered
  },
  badgeStyle: {
    position: 'absolute',
    top: '-4px',
    right: '-2px',
    padding: '3px 7px',
    background: theme.palette.colors.white,
    color: theme.palette.primary.main,
    fontSize: '12px',
    lineHeight: 'normal',
    borderRadius: '10px',
  }
}));

export default useStyles;
